module.exports = __webpack_public_path__ + "img/parantica-sita-butterfly.3635d616.png";